module.exports = __webpack_public_path__ + "img/FourSig-01.b2663b4d.png";